export const ACTION_ITEM_COLUMN = 1;

export const ACTION_TYPE = {
  MANUAL: 1,
  CLIENT_FOLLOW_UP: 2,
  LAW_FIRM_FOLLOW_UP: 3,
  PROVIDER_FOLLOW_UP: 4,
};

export const ACTIONABLE_ITEM_TYPE_STRING = {
  1: "Manual",
  2: "Client Follow Up",
  3: "Law Firm Follow Up",
  4: "Provider Follow Up",
};

export const ACTIONABLE_ITEM_OBJ_MAPPING = {
  2: "onCase",
  3: "onFirm",
  4: "onProvider",
};

export const NULL_STRING = "No content to show";

const baseStyles = {
  borderRadius: "5px",
  backgroundColor: "#fff",
  color: "#505050",
  fontSize: "14px",
  lineHeight: "38px",
  height: "38px",
  textAlign: "center",
  "& fieldset": {
    borderColor: "#505050",
  },
  "& input": {
    padding: "0 !important",
  },
};

export const inputStyles = {
  "& .MuiOutlinedInput-root": {
    ...baseStyles,
    padding: "11px 8px",
  },
};

export const selectStyles = {
  ...baseStyles,
  "& .MuiOutlinedInput-input": {
    padding: "11px 8px",
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
  },
};

export const autoCompleteStyles = {
  "& .MuiOutlinedInput-root": {
    ...baseStyles,
    paddingLeft: "8px",
  },
};

export const dateTimeStyles = {
  ...inputStyles,
  "& input": {
    marginLeft: "-8px",
  },
};

export const MAX_TYPE_PER_PROVIDER = 5;
